import { render, staticRenderFns } from "./edition.vue?vue&type=template&id=74e8c9b6"
import script from "./edition.vue?vue&type=script&lang=js"
export * from "./edition.vue?vue&type=script&lang=js"
import style0 from "./edition.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports